<template>
  <div id="ylAboutCollapse">
    <ylAboutCollapseMobile v-if="isMobileScreen" v-bind="$attrs" :list="list" />
    <ylAboutCollapsePC v-else v-bind="$attrs" :list="list" />
  </div>
</template>
<script>
export default {
  name: "ylAboutCollapse",
  components: {
    ylAboutCollapseMobile: () => import("./components/mobile.vue"),
    ylAboutCollapsePC: () => import("./components/pc.vue"),
  },
  data() {
    return {
      list: []
    };
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  created() {
    this.coreTeams()
  },
  methods: {
    async coreTeams() {
      let res = await this.$api.coreTeams();
      this.list = res
    },
  },
};
</script>